import EditQCode from "../chatEdit/sections/EditQCode";

export default function TableViewQCodes({ value, setValue, initValue, chat }) {
  return (
    <div className="qcodes-table">
      <EditQCode
        qcode={initValue?.[0]}
        chat={chat}
        onChange={(code) => {
          console.log("code", code);
          setValue([code]);
        }}
      />
    </div>
  );
}
